import React, { useContext } from "react";

import { Headline } from "../../../Headline";
import { Button } from "../../../Button";

import t from "../../../../lib/translate";

import * as styles from "./divisionInformation.module.less";
import GeneralPageContext from "../../../../templates/GeneralPageContext";

export default function DivisionInformation({ name, phone, contactUrl }) {
    const {
        stdPages: { pageContact }
    } = useContext(GeneralPageContext);
    return (
        <div className={styles.content}>
            <Headline semanticOfHeadline={"H5"} hasLightBackground={true}>
                {name}
            </Headline>
            <div className={styles.contentDetail}>
                <Button
                    renderAs="link"
                    to={`tel:${phone.replace(/\s/g, "")}`}
                    type={"secondary"}
                    className={styles.contactButtonPhone}
                    icon={"phone"}
                    iconPosition={"left"}
                >
                    {phone}
                </Button>
                <Button
                    renderAs="link"
                    to={contactUrl ?? pageContact.url}
                    type={"secondary"}
                    className={styles.contactButtonMail}
                    icon={"mail"}
                    iconPosition={"left"}
                >
                    {t("navigation.language.switcher.contact-us")}
                </Button>
            </div>
        </div>
    );
}
